import { create } from 'zustand';

export type TabKey = 'closed' | 'admin';

export type AuthStatus = 'pending' | 'authed' | 'needs-login';

export interface ToastState {
  id: number;
  text: string;
  createdAt: number;
  ttlMs: number;
}

interface AppState {
  tab: TabKey;
  authStatus: AuthStatus;
  toast: ToastState | null;
  setTab: (tab: TabKey) => void;
  setAuthStatus: (status: AuthStatus) => void;
  showToast: (text: string, opts?: { ttlMs?: number }) => void;
  dismissToast: () => void;
}

export const useStore = create<AppState>()((set) => ({
  tab: 'closed',
  authStatus: 'pending',
  toast: null,
  setTab: (tab) => set({ tab }),
  setAuthStatus: (status) => set({ authStatus: status }),
  showToast: (text, opts) =>
    set({
      toast: { id: Date.now(), text, createdAt: Date.now(), ttlMs: opts?.ttlMs ?? 5000 },
    }),
  dismissToast: () => set({ toast: null }),
}));
